import { IMultiStateSwitch } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { themedUseStyletron } from '../../../theme/customTheme';
import { BsMenuButtonWide } from 'react-icons/bs';
import { ButtonsPanel } from './ButtonsPanel';


export function OverviewPanel(props: IMultiStateSwitch) {
  const [, theme] = themedUseStyletron();
  return (
    <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props} icon={<BsMenuButtonWide size={'100%'} color={theme.colors.backgroundPrimary}></BsMenuButtonWide>}>
      <ButtonsPanel buttonSize='compact' {...props}></ButtonsPanel>
    </OverviewPanelWrapper>
  );
}